import { render } from "./questionSelect.vue?vue&type=template&id=efae4532&scoped=true"
import script from "./questionSelect.vue?vue&type=script&lang=js"
export * from "./questionSelect.vue?vue&type=script&lang=js"

import "./questionSelect.vue?vue&type=style&index=0&id=efae4532&scoped=true&lang=scss"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efae4532"]])

export default __exports__